import React from "react";
import { motion } from "framer-motion";
import SectionHead from "./SectionHead";
import Tilt from "./Tilt";
import { img, inView, rise, stagger } from "./utils";

const TINTS = ["#c9ffef", "#ffd5d1", "#c7d0da", "#5ee3e7"];

const LEDE =
  "At Bapat Optics, we bring the world of luxury eyewear closer to you through our collaborations with some of the most prestigious names in global eyewear. Our exclusive collection brings together iconic design, exceptional craftsmanship and timeless sophistication, featuring authentic, original products from renowned international brands. Every brand we curate reflects our pursuit of excellence and our belief that true luxury lies in the finest details. At Bapat Optics, authenticity is our promise, quality is our standard, and exceptional eyewear is our legacy.";

const Brands = ({ brands = [] }) => {
  if (!brands.length) return null;
  return (
    <section id="brands" className="au-sec au-sec--mint">
      <div className="au-wrap">
        <SectionHead eyebrow="Collaborations" title="Brands and collaborations" lede={LEDE} />
        <motion.ul className="au-brands" variants={stagger} initial="hide" whileInView="show" viewport={inView}>
          {brands.map((b, i) => (
            <Tilt as="li" key={b.id} className="au-brand" variants={rise} max={7}>
              <div className="au-brand__img" style={{ background: TINTS[i % TINTS.length] }}>
                {b.image ? <img src={img(b.image)} alt={`${b.name} eyewear`} loading="lazy" /> : <span>{b.name}</span>}
              </div>
              <div className="au-brand__meta">
                {b.logo ? <img src={img(b.logo)} alt={b.name} className="au-brand__logo" /> : <strong>{b.name}</strong>}
                {b.tagline && <span>{b.tagline}</span>}
              </div>
            </Tilt>
          ))}
        </motion.ul>
      </div>
    </section>
  );
};

export default Brands;